
<div v-show="active" :class="magicClasses" :style="magicStyle"></div>
